import React from 'react'
import { RewardsHubDto } from '@/api/Trading-Accounts/Types/RewardsHubDto'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface OuterProps {
  isOpen?: boolean
  onClose(): void
  entity?: RewardsHubDto
  onConfirm(entity: RewardsHubDto): void
}

export const StatusConfirmationModal: React.FC<OuterProps> = (props) => {
  return (
    <Dialog open={props.isOpen} onOpenChange={(open) => !open && props.onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{'Are you sure you want to change status?'}</DialogTitle>
        </DialogHeader>

        <DialogFooter>
          <Button type='button' onClick={props.onClose}>
            Cancel
          </Button>
          <Button
            type='button'
            onClick={() => {
              if (props.entity) {
                props.onConfirm(props.entity)
              }
              props.onClose()
            }}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
